import { useState } from "react";
import { Autocomplete, TextField, Chip, Box, Typography, Button } from "@mui/material";
import Colors from "../../../assets/Variables/ColorsVariables";
import * as TextVariables from "../../../assets/Variables/TextVariables.js";
import * as ColorsVariables from "../../../assets/Variables/ColorsVariables.js";

const TextInputWithChips = (props) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showChips, setShowChips] = useState(true);

  const handleInputChange = (newInputValue) => {
    setInputValue(newInputValue);

    if (newInputValue.trim() === "") {
      setFilteredOptions([]);
      return;
    }

    const filtered = props.options.filter((opt) =>
      opt.toLowerCase().includes(newInputValue.toLowerCase())
    );
    setFilteredOptions(filtered);
  };

  const handleChange = (event, newValue) => {
    props.onSelectedOptions(newValue);
  };

  return props.options && props.options.length > 0 ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "4px",
      }}
    >
      {/* Título + Botón */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: props.width || "250px", }}>
        <Typography
          sx={{
            color: ColorsVariables.Colors.Secondary_700,
            fontFamily: TextVariables.Caption_1,
          }}
        >
          {props.title}
        </Typography>

        {props.selectedOptions.length > 0 && (
          <Button
            variant="text"
            size="small"
            onClick={() => setShowChips(!showChips)}
            sx={{
              fontSize: "10px",
              textTransform: "none",
              fontFamily: TextVariables.Overline,
              color: Colors.Secondary_500,
              padding: 0,
              minWidth: "auto",
              "&:hover": {
                backgroundColor: "transparent",
                textDecoration: "underline",
              },
            }}
          >
            {showChips ? "hide selection" : "show selection"}
          </Button>
        )}
      </Box>

      {/* Input + Chips */}
      <Box sx={{ position: "relative", width: props.width || "250px" }}>
        <Autocomplete
          multiple
          freeSolo
          disableCloseOnSelect
          options={filteredOptions}
          value={props.selectedOptions}
          inputValue={inputValue}
          onInputChange={(e, newInputValue) =>
            handleInputChange(newInputValue)
          }
          onChange={handleChange}
          renderTags={() => null}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Multiple Search..."
              variant="outlined"
              sx={{
                width: "100%",
                height: props.height || "38px",
                "& .MuiOutlinedInput-root": {
                  height: props.height || "38px",
                  borderRadius: "8px",
                  padding: "0px 8px",
                  fontFamily: TextVariables.Overline,
                  fontSize: "12px",
                  backgroundColor: "#fff",
                  border: `1px solid ${Colors.Secondary_400}`,
                  "& fieldset": { border: "none" },
                },
                "& .MuiInputBase-input": {
                  padding: 0,
                  fontFamily: TextVariables.Overline,
                  fontSize: "12px",
                },
                "& input::placeholder": {
                  fontFamily: TextVariables.Overline,
                  fontSize: "12px",
                },
              }}
            />
          )}
        />

        {showChips && props.selectedOptions.length > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              zIndex: 10,
              mt: "4px",
              maxHeight: "100px",
              overflowY: "auto",
              width: "100%",
              backgroundColor: "#fff",
              border: `1px solid ${Colors.Secondary_400}`,
              borderRadius: "8px",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              padding: "6px",
            }}
          >
            {props.selectedOptions.map((option, index) => (
              <Chip
                key={index}
                label={option}
                onDelete={() => {
                  const newOptions = props.selectedOptions.filter(
                    (_, i) => i !== index
                  );
                  props.onSelectedOptions(newOptions);
                }}
                sx={{
                  height: "24px",
                  fontSize: "12px",
                  fontFamily: TextVariables.Overline,
                  backgroundColor: Colors.Secondary_100,
                }}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  ) : null;
};

export default TextInputWithChips;
